export class BadRequest extends Error {
    public errors?: Array<{ description: string }>;

    public constructor(message?: string, errors?: Array<{ description: string }>) {
        super(message);

        this.errors = errors;
    }
}
